import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-transfer-approve-link',
  templateUrl: './asset-transfer-approve-link.component.html',
  styleUrls: ['./asset-transfer-approve-link.component.scss']
})
export class AssetTransferApproveLinkComponent {

}
